export default (state = { isAuthenticated: false }, action) => {
    switch (action.type) {
        case 'USER_DETAILS': {
            if (action.isAuthenticated) {
                return Object.assign(Object.assign({}, state), { name: action.name, email: action.email, isAuthenticated: true, conditionsAccepted: action.conditionsAccepted, isAuthenticatedWithNemid: action.isAuthenticatedWithNemid });
            }
            return Object.assign({}, state);
        }
        default: {
            return state;
        }
    }
};
